import React, { Component, Fragment } from "react";
import ExportsIndex from "../../Components/ProducaoSTI/Realizado/Exports/Index";
import TabelaMetaRealizado from "../../Components/ProducaoSTI/Realizado/Relatorio3/Index";
import NomeUnidade from "../../Components/UI/NomeUnidade";
import MenuRelatorioSTI from "./menuRelatorioSTI";

export default class PageExportsSTI extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Relatório"
        }
        
    }

    render() {
        return(
            <Fragment>

                <NomeUnidade unidade={"Relatórios"} />

                <div className="content">
                    <MenuRelatorioSTI />
                    <div className="row">
                        <div className="col-md-12">
                            <ExportsIndex />
                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }
}